<template>
  <div v-show="selectedTab.tabId" id="register-departDoctor-doctorList">
    <no-record :condition="doctors" tips="没有找到医生信息"></no-record>
    <ul class="">
      <li
        @click="onSelectedDoctor(item, index, $event)"
        v-for="(item, index) in doctors"
        class="doctor-list-section"
        :id="'register-departDoctor-li-doct-' + index"
      >
        <div class="doctor-list-schedule-info">
          <div
            class="head doc-header"
            v-bind:style="{
              backgroundImage:
                'url(' +
                (item.doctAvatar
                  ? item.doctAvatar
                  : '../../../static/img/ico-doctor.png') +
                ')',
            }"
          ></div>
          <div class="info">
            <!-- 第一行，医生级别和名称 -->
            <p class="f-large ellipsis">
              {{ item.doctLevel }}&nbsp;{{ item.doctName }}
            </p>
            <!-- 第二行，科室名称 -->
            <div
              class="flex-row flex-align-center arr-row"
              style="border-bottom: none"
            >
              <p class="f-minor ellipsis" style="margin-top: 0.15rem">
                {{ item.deptName }}
              </p>
            </div>
            <!-- 第三行，医生介绍和更多同一行 -->
            <div
              class="flex-row flex-align-end"
              @click="openRemain(item, $event)"
            >
              <p
                :id="'doctor-remain-' + index"
                class="flex-1 f-small f-minor"
                :class="
                  item.showDetailRemain
                    ? 'doctor-list-remain-open'
                    : 'doctor-list-remain-close'
                "
              >
                {{ item.doctDesc ? item.doctDesc : "暂无介绍" }}
              </p>
              <span
                v-show="item.hasMoreRemain"
                :class="item.showDetailRemain ? 'arrow-up' : 'arrow-down'"
              ></span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import NoRecord from 'NoRecord';

export default {
  props: {
    selectedTab: Object,
    selectedArea: Object,
    doctors: Array
  },
  components: {
    NoRecord
  },
  mounted () {
    this.refresh();
  },
  computed: {},
  data () {
    return {
      selectedDoctor: {},
    };
  },
  methods: {
    openRemain (item, event) {
      // 如果该医生简介可以拓展，则该点击事件阻止冒泡
      if (item.hasMoreRemain) {
        event.cancelBubble = true
      }
      item.showDetailRemain = !item.showDetailRemain
    },
    refresh () {
      this.selectedDoctor = {}
    },

    onSelectedDoctor: function (item) {
      this.selectedDoctor = item;
      this.$store.commit('updateParam', {
        namespace: 'register',
        doc: item,
        area: this.selectedArea
      })
      window.localStorage.tabId = "1";
      this.$router.push('DateTimeSchedule');
    },
  },
  watch: {
    /* eslint-disable */
    doctors (val) {
      // 等doom元素绘制完成后，判断每个简介是否超出(如果不超出则不需要拓展)
      this.$nextTick(() => {
        if (this.doctors.length > 0) {
          for (let i = 0; i < this.doctors.length; i++) {
            const id = 'doctor-remain-' + i
            let clientHeight = document.getElementById(id).clientHeight
            let scrollHeight = document.getElementById(id).scrollHeight
            this.doctors[i].hasMoreRemain = clientHeight < scrollHeight
          }
        }
      })
    }
  },

}
</script>

<style lang="scss">
@import "../../../static/sass/_variable.scss";

.doctor-list-section {
  position: relative;
  @include border(bottom);
  background: #fff;
}

.doctor-list-schedule-info {
  @include display-flex();
  padding: 0.4rem 0 0.4rem 0.4rem;
  .head {
    width: 60px;
    height: 60px;
    margin-top: 10px;
  }
  .info {
    @include flex(1);
    width: 1px;
    padding-left: 10px;
    .arrow-down {
      margin-right: 0.5rem;
      margin-bottom: 2px;
      width: 15px;
      height: 8px;
      background: url(../../../static/img/arrow-down.png) 100% 100% no-repeat;
      background-size: 100%;
    }
    .arrow-up {
      margin-right: 0.5rem;
      margin-bottom: 2px;
      width: 15px;
      height: 8px;
      background: url(../../../static/img/arrow-up.png) 100% 100% no-repeat;
      background-size: 100%;
    }
  }
  .doctor-list-remain-close {
    @include maxLine-ellipsis(2);
  }
  .doctor-list-remain-open {
    @include maxLine-ellipsis(99);
  }
}
</style>


// WEBPACK FOOTER //
// DoctorList.vue?77c96d54